import GoalsTemplate from './goals.html';

export default angular
  .module('main.devices.edit.tabs.goals', [])

  .directive('editDeviceGoalsTab', () => {
    return {
      restrict: 'E',
      template: GoalsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   utils,
                   ToastsService,
                   EditDeviceDataProvider) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;

        angular.extend($scope, {
          goToLocation: goToLocation,
          setCurrentGoal: setCurrentGoal
        });

        init();

        function init() {
          $scope.loading = true;
          return $q.all([
            $scope.dataProvider.deviceResource.init(),
            $scope.dataProvider.deviceGoalsResource.init(),
            $scope.dataProvider.isBotDrivenGoalsResource.init(),
            $scope.dataProvider.deviceRulesResource.init()
          ])
            .then(() => {
              initWatchers();
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              // utils.handleApiError(err);
            });
        }

        function initWatchers() {
          $scope.$watchGroup([
            'dataProvider.deviceRulesResource.value',
            'dataProvider.deviceGoalsResource.value',
            'dataProvider.deviceResource.value.goalId',
            'dataProvider.isBotDrivenGoalsResource.value'
          ], () => {
            initViewModel();
          }, true);
        }

        function initViewModel() {
          $scope.goals = angular.copy($scope.dataProvider.deviceGoalsResource.value);
          let deviceGoalId = $scope.dataProvider.deviceResource.value.goalId;
          if (deviceGoalId) {
            $scope.scenarioRules = angular.copy($scope.dataProvider.deviceRulesResource.value
              .filter(rule => rule.goalId != null && deviceGoalId != null && rule.goalId === deviceGoalId));
          } else {
            $scope.scenarioRules = [];
          }

          $scope.isBotDrivenGoals = !!$scope.dataProvider.isBotDrivenGoalsResource.value;
        }

        function goToLocation() {
          $scope.dataProvider.goToDeviceLocation('bots');
        }

        function setCurrentGoal(goal) {
          $scope.loading = true;
          $scope.dataProvider.setCurrentDeviceGoal(goal)
            .then(() => {
              ToastsService.success();
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }
      }
    };
  })
  .name;
